import { useMutation, useQuery } from "@tanstack/react-query";
import { executeQuery } from "../../../utils";
import { DataTableContextProvider } from "../DataTable/DataTableContext";
import { DataTable } from "../DataTable/DataTable";
import PrivilegeCell from "./PrivilegeCell";
import IpCell from "./IpCell";
import axios from "axios";
import { deltamathAPI } from "../../utils";

const SupportManagePermissions = () => {
  const updateEmployeeMutation = useMutation({
    mutationFn: (body: {
      teacherCode: string;
      privileges: string | undefined;
      ips: string | undefined;
    }) => {
      return axios.post(
        `${deltamathAPI()}/manager_new/support/employee-ips`,
        JSON.stringify(body),
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
    },
  });

  const updateEmployee = (
    teacherCode: string,
    body: {
      privileges: string | undefined;
      ips: string | undefined;
    }
  ) => {
    updateEmployeeMutation.mutate({ teacherCode, ...body });
  };

  return (
    <div className="p-10">
      <h2>Manage Permissions</h2>
      <DataTableContextProvider
        source="/manager_new/support/employee-ips"
        queryKey="employee-ips"
        sortable={["name"]}
        defaults={{ sortBy: [{ id: "name", desc: false }] }}
        downloadButton={false}
        fetchOnLoad
        columnOverrides={{
          ips: ({ row }) => (
            <IpCell
              employeeId={(row as any).original._id}
              employeeName={(row as any).original.name}
              ips={(row as any).original.ips?.split(",")}
              updateEmployee={updateEmployee}
            />
          ),
          privileges: ({ row }) => (
            <PrivilegeCell
              employeeId={(row as any).original._id}
              employeeName={(row as any).original.name}
              privileges={(row as any).original.privileges?.split(",")}
              updateEmployee={updateEmployee}
            />
          ),
        }}
      >
        <DataTable />
      </DataTableContextProvider>
    </div>
  );
};

export default SupportManagePermissions;
